import type { UseQueryOptions, UseQueryResult } from 'react-query';
import { useQuery } from 'react-query';

import type { IQueryKeyFactory } from '~/helpers/types';
import type { ApiError } from '~/lib/api';
import type { IApiGetArticleDraftResponseBody } from '../ArticlesApi.types';
import { useApi } from '~/lib/api/useApi';

export type IUseArticleDraftQueryValues = {
  appId: string;
  articleId: string;
};

export const articleDraftQueryKeyFactory: IQueryKeyFactory<
  IUseArticleDraftQueryValues
> = (values) =>
  values && (['articleDraft', values.appId, values.articleId] as const);

export const useArticleDraftQuery = (
  values?: IUseArticleDraftQueryValues,
  options?: UseQueryOptions<IApiGetArticleDraftResponseBody, ApiError>,
): UseQueryResult<IApiGetArticleDraftResponseBody, ApiError> => {
  const api = useApi();

  return useQuery({
    queryKey: articleDraftQueryKeyFactory(values),
    queryFn: values
      ? () => api.articles.getDraft(values.appId, values.articleId)
      : undefined,
    enabled: !!values,
    ...options,
  });
};
